<template>
  <div class="message-box">
    <div class="card">
      <vs-button
        class="card-header"
        type="flat"
        @click="toggleMessageBoxVisibility"
        icon="edit"
      >
        <p style="font-weight: 400">
          {{ "پاسخ" }}
        </p>
      </vs-button>
      <div
        v-bind:style="{ display: messageBoxVisible ? 'inline' : 'none' }"
        class="mt-4 p-4"
      >
        <form-content ref="formContent" />
        <attachments ref="formAttachments" class="my-10" title="ضمیمه ها" />
        <div class="button">
          <vs-button @click="reply">
            {{ "ارسال" }}
          </vs-button>
          <vs-button @click="cancel" color="#EA5455" class="ml-5">
            {{ "لغو" }}
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";
import Attachments from "../form/Attachments.vue";
import FormContent from "../form/FormContent.vue";

export default {
  name: "MessageBox.vue",
  components: { FormContent, Attachments },
  data() {
    return {
      messageBoxVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    toggleMessageBoxVisibility() {
      this.messageBoxVisible = !this.messageBoxVisible;
    },
    reply() {
      /**
       * Get the form data and attachments
       */
      const content = this.$refs["formContent"].getData();
      const attachments = this.$refs["formAttachments"].getData();

      /**
       * Send request to server with given data
       */
      this.$vs.loading();
      providerApiService
        .postReplyTicket({
          id: this.ticketId,
          content: content.content,
          attachments,
          providerId: this.currentProvider.id,
        })
        .then((result) => {
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
          this.$emit("onTicketReplied", result.data);
          this.toggleMessageBoxVisibility();
        })
        .finally(() => this.$vs.loading.close());
    },
    cancel() {
      this.toggleMessageBoxVisibility();
    },
  },
  props: {
    ticketId: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.message-box {
  flex: 1;

  .card {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
    display: flex;
    flex-direction: column;
    margin-bottom: 25px;

    .card-header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>

